/* ==========================================================================
   SpotMyStuff — Customer Reviews Carousel section
   Arrow-driven scrollBy on the reviews track. Reproduces the handoff's
   own script.js carousel behavior exactly (same step distance for this
   track — 458, vs. the use-case track's 360 — same Math.min(step,
   clientWidth * 0.85) formula, same smooth scrollBy) — no slider
   library, no autoplay, no index state. The track itself is natively
   swipeable/scrollable (CSS scroll-snap) independent of these buttons;
   this script only wires the two arrow buttons to it.

   Same self-contained IIFE pattern as spotmystuff-usecases.js (own
   namespace, own DOMContentLoaded guard) — this is a separate carousel
   instance on the page with its own step distance and element ids, not
   a shared/duplicated copy of that file's logic.
   ========================================================================== */

(function () {
  'use strict';

  var STEP = 458;

  function initCarousel(root) {
    var track = root.querySelector('[data-spotmystuff-reviews-track]');
    var prevBtn = root.querySelector('[data-spotmystuff-reviews-prev]');
    var nextBtn = root.querySelector('[data-spotmystuff-reviews-next]');
    if (!track) return;

    function scrollByDir(dir) {
      var distance = Math.min(STEP, track.clientWidth * 0.85);
      track.scrollBy({ left: dir * distance, behavior: 'smooth' });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () { scrollByDir(-1); });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () { scrollByDir(1); });
    }
  }

  function init() {
    var sections = document.querySelectorAll('.spotmystuff-reviews');
    sections.forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
